<div class="container-fluid banner">
  <img src="../../assets/Registration.jpg" class="img-responsive" style="width: 100%;">
  <div class="top-left">
    <h1>Registration </h1>
  </div>
</div>
<div class="container">
  <div class="row">
    <h5>Personal<small class="imp_mark">*</small></h5>
  </div>
  <form class="form-inline" id="scrollForError" novalidate [formGroup]="doctorRegistrationForm">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="firstName">First Name:</label>
          <input type="text" id="firstName" class="form-control" placeholder="Enter First Name" name="firstName"
            formControlName="firstName">

          <div
            *ngIf="doctorRegistrationForm.get('firstName').hasError('required') && doctorRegistrationForm.get('firstName').touched">
            <small class="error">Firstname should not be empty</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('firstName').hasError('minlength')&& doctorRegistrationForm.get('firstName').touched">
            <small class="error">Firstname should contain minimum 3 characters</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('firstName').hasError('maxlength')&& doctorRegistrationForm.get('firstName').touched">
            <small class="error">Firstname should contain maximum 35 characters</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('firstName').hasError('pattern')&& doctorRegistrationForm.get('firstName').touched">
            <small class="error">Please enter only alphabets</small>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="lastName">Last Name<span></span>: </label>
          <input type="text" id="lastName" class="form-control" placeholder="Enter Last Name" name="lastName"
            formControlName="lastName">
          <div
            *ngIf="doctorRegistrationForm.get('lastName').hasError('required') && doctorRegistrationForm.get('lastName').touched">
            <small class="error">Lastname should not be empty</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('lastName').hasError('minlength')&& doctorRegistrationForm.get('lastName').touched">
            <small class="error">Lastname should contain minimum 3 characters</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('lastName').hasError('maxlength')&& doctorRegistrationForm.get('lastName').touched">
            <small class="error">Lastname should contain maximum 35 characters</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('lastName').hasError('pattern')&& doctorRegistrationForm.get('lastName').touched">
            <small class="error">Please enter only alphabets</small>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="sel1">Gender:</label>
          <select id="sel1" class="form-control" formControlName="genderId">
            <option value="">Select Gender</option>
            <option *ngFor="let gender of genders" value="{{gender?.genderId}}">{{gender.genderName}}</option>
          </select>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('genderId').hasError('required')&& doctorRegistrationForm.get('genderId').touched">
          <small class="error">Please select gender</small>
        </div>
      </div>
    </div>
    <!--===========================-->
    <div class="row" id="forExitEmail">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="dob">DOB:</label>
          <input type="date" id="dob" min="1920-01-01" class="form-control" placeholder="Enter Last Name "
            max="{{maxdate| date:'yyyy-MM-dd'}}" name="dob" formControlName="dob">
        </div>
        <div *ngIf="doctorRegistrationForm.get('dob').hasError('required')&& doctorRegistrationForm.get('dob').touched">
          <small class="error">Please enter the date of birth</small>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" id="email" class="form-control" placeholder="Enter email" name="email"
            formControlName="email" (change)="emailValidation()">
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('email').hasError('required')&& doctorRegistrationForm.get('email').touched">
          <small class="error">Please enter the email</small>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('email').hasError('pattern')&& doctorRegistrationForm.get('email').touched">
          <small class="error">Please enter valid email</small>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('email').hasError('exist')&& doctorRegistrationForm.get('email').touched">
          <div class="error">
            <p> {{getReq.message|titlecase}}</p>
          </div>
        </div>
        <div class="error" *ngIf="formErrors?.bool">{{formErrors.data.email}}</div>
      </div>
       <!-- <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="password">Password:</label>
          <input type="password" id="password" class="form-control" placeholder="Enter Password" name="password"
            formControlName="password">
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('password').hasError('required')&& doctorRegistrationForm.get('password').touched">
          <small class="error">Please enter password</small>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('password').hasError('minlength')&& doctorRegistrationForm.get('password').touched">
          <small class="error">Please should contain 6 characters</small>
        </div>
      </div> -->
    </div>
    <!------------------------------>
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="password">Password:</label>
            <input type="password" id="password" class="form-control" placeholder="Enter Password" name="password"
              formControlName="password">
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('password').hasError('required')&& doctorRegistrationForm.get('password').touched">
            <small class="error">Please enter password</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('password').hasError('minlength')&& doctorRegistrationForm.get('password').touched">
            <small class="error">Please should contain 6 characters</small>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="confirmPassword">Confirm password</label>
            <input type="password" class="form-control" placeholder="Enter Confirm password" formControlName="confirmPassword">
            <div *ngIf="f?.confirmPassword?.errors && f?.confirmPassword?.touched" class="error">
              <div *ngIf="f?.confirmPassword?.errors?.required">Confirm password is required</div>
              <div *ngIf="f?.confirmPassword?.errors?.matchPassword">New password and Confirm password didn't match. </div>
            </div>
          </div>
        </div>

    </div> 
    <!--===========================-->
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="country">Country:</label>
          <select id="country" class="form-control" formControlName="country" (change)="getState($event)">
            <option value="" disabled>Select Country</option>
            <option *ngFor="let country of countries" value="{{country?.countryId}}">{{country.countryName}}</option>
          </select>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('country').hasError('required')&& doctorRegistrationForm.get('country').touched">
          <small class="error">Please select country</small>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="country">State:</label>
          <select id="state" class="form-control" formControlName="state" (change)="getCity($event)">
            <option value="">Select State</option>
            <!--<option value="null"></option> *ngIf="showDisabled">Select Country</option>-->
            <option *ngFor="let state of states" value="{{state.stateId}}">{{state.stateName}}</option>
          </select>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('country').hasError('required')&& doctorRegistrationForm.get('state').touched;else selectState">
          <small class="error">Please first select country</small>
        </div>
        <ng-template #selectState>
          <div
            *ngIf="doctorRegistrationForm.get('state').hasError('required')&& doctorRegistrationForm.get('state').touched">
            <small class="error">Please select state</small>
          </div>
        </ng-template>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">

        <div class="form-group">
          <label for="city">City:</label>
          <select id="city" class="form-control" formControlName="city">
            <option value="">Select City</option>
            <!--<option value="null" *ngIf="showDisabled">Select Country</option>-->
            <option *ngFor="let city of cities" value="{{city.cityId}}">{{city.cityName}}</option>
          </select>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('state').hasError('required')&& doctorRegistrationForm.get('city').touched;else selectCity">
          <small class="error">Please first select state</small>
        </div>
        <ng-template #selectCity>
          <div
            *ngIf="doctorRegistrationForm.get('city').hasError('required') && doctorRegistrationForm.get('city').touched">
            <small class="error">Please select city</small>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="zip">Zip Code:</label>
          <input type="text" id="zip" class="form-control" placeholder="Enter ZipCode" name="zipcode" maxlength="9"
            formControlName="zip">
        </div>
        <div *ngIf="doctorRegistrationForm.get('zip').hasError('required')&& doctorRegistrationForm.get('zip').touched">
          <small class="error">Please enter zipcode</small>
        </div>
        <div *ngIf="doctorRegistrationForm.get('zip').hasError('pattern')&& doctorRegistrationForm.get('zip').touched">
          <small class="error">Please enter in digits</small>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="phone">Phone Number:</label>
          <input type="text" id="phone" class="form-control" placeholder="Enter phone Number" name="mobile"
            formControlName="mobile">
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('mobile').hasError('required')&& doctorRegistrationForm.get('mobile').touched">
          <small class="error">Please enter phone number</small>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('mobile').hasError('pattern')&& doctorRegistrationForm.get('mobile').touched;else test">
          <small class="error">Please enter in digits</small>
        </div>
        <ng-template #test>
          <div
            *ngIf="doctorRegistrationForm.get('mobile').hasError('minlength')&& doctorRegistrationForm.get('mobile').touched">
            <small class="error">Please enter minimum 10 digits</small>
          </div>
          <div
            *ngIf="doctorRegistrationForm.get('mobile').hasError('maxlength')&& doctorRegistrationForm.get('mobile').touched">
            <small class="error">Please enter maximum 10 digits</small>
          </div>
        </ng-template>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="addrLine1">Address: </label>
          <textarea class="form-control" id="addrLine1" rows="3" formControlName="addrLine1"></textarea>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('addrLine1').hasError('required')&& doctorRegistrationForm.get('addrLine1').touched">
          <small class="error">Please enter address</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label for="languagesKnownSpeak">Languages known to speak: </label>
          <ng-multiselect-dropdown [placeholder]="'Languages known to speak'" [settings]="ddSettingsToSpeak"
              [data]="languageList" formControlName="languagesKnownSpeak" >
          </ng-multiselect-dropdown>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('languagesKnownSpeak').hasError('required')&& doctorRegistrationForm.get('languagesKnownSpeak').touched">
          <small class="error">Please select the language known</small>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">


        <div class="form-group">
          <label for="languagesKnownReadWrite">Languages known to Read Write: </label>
          <ng-multiselect-dropdown [placeholder]="'Languages known to read write'" [settings]="ddSettingsToSW"
            [data]="languageList" formControlName="languagesKnownReadWrite">
          </ng-multiselect-dropdown>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('languagesKnownReadWrite').hasError('required')&& doctorRegistrationForm.get('languagesKnownReadWrite').touched">
          <small class="error">Please select the language known</small>
        </div>
      </div>


      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="doctorSpecialities">Specialities: </label>
          <ng-multiselect-dropdown [placeholder]="'Select specialities'" [settings]="ddSettingToSpecilities"
            [data]="specaiality_list" formControlName="doctorSpecialities">
          </ng-multiselect-dropdown>
        </div>
        <div
          *ngIf="doctorRegistrationForm.get('doctorSpecialities').hasError('required')&& doctorRegistrationForm.get('doctorSpecialities').touched">
          <small class="error">Please select the speciality</small>
        </div>
      </div>
    </div>
    <!--===========================-->
    <div class="row" id="forTimeCheck" [formGroup]=setTimings>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="AvailableStartTime">Available-Start-Time:</label>
          <input type="text" class="form-control" [min]="startAt" [max]="endAt" [owlDateTime]="starttime"
            [owlDateTimeTrigger]="starttime" name="AvailableStartTime" placeholder="Start Time"
            (dateTimeChange)="changeTime('availabilityStartTime')" formControlName="startTime">
          <owl-date-time [pickerType]="'timer'" [hour12Timer]=true [startAt]="getTime" [stepMinute]='30' #starttime>
          </owl-date-time>
          <div *ngIf="setTimings.get('startTime').hasError('required')&& setTimings.get('startTime').touched">
            <small class="error">Please select the availability start time</small>
          </div>
          <div *ngIf="setTimings.get('startTime').hasError('greaterValue')&& setTimings.get('startTime').touched">
            <div class="error">
              <p> Start-time must be less than End-time </p>
            </div>
          </div>
          <!-- <div  *ngIf="checkTime">
            <div class="error"><p> Start-time must be less than End-time </p></div>
          </div> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="AvailableEndTime">Available-End-Time:</label>
          <input type="text" class="form-control" placeholder="End Time" name="AvailableEndTime" [min]="startAt"
            (dateTimeChange)="changeTime('availabilityEndTime')" [max]="endAt" formControlName="endTime"
            [owlDateTime]="endtime" [owlDateTimeTrigger]="endtime">
          <owl-date-time [pickerType]="'timer'" [stepMinute]='30' [hour12Timer]=true [startAt]="getTime1" #endtime>
          </owl-date-time>
          <div *ngIf="setTimings.get('endTime').hasError('required')&& setTimings.get('endTime').touched">
            <small class="error">Please select the closed end time</small>
          </div>

        </div>
      </div>
    </div>
    <br>



    <div class="row">
      <h5>Education</h5>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="graduatedegree">Graduate Degree<small class="imp_mark">*</small>: </label>
          <input type="text" id="graduatedegree" name="graduatedegree" class="form-control"
            formControlName="graduatedegree">
          <!-- <button type="button" class="bb"><span class="glyphicon glyphicon-plus"></span> Add</button> -->
        </div>

        <div
          *ngIf="doctorRegistrationForm.get('graduatedegree').hasError('required')&& doctorRegistrationForm.get('graduatedegree').touched">
          <small class="error">Please fill the field</small>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="graduatecollege">Graduate College<small class="imp_mark">*</small>: </label>
          <input type="text" id="graduatecollege" name="graduatecollege" class="form-control"
            formControlName="graduatecollege">
          <!-- <button type="button" class="bb"><span class="glyphicon glyphicon-plus"></span> Add</button> -->

          <div
            *ngIf="doctorRegistrationForm.get('graduatecollege').hasError('required')&& doctorRegistrationForm.get('graduatecollege').touched">
            <small class="error">Please fill the field</small>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="postgraduatedegree">Postgraduate Degree: </label>
          <input type="text" id="postgraduatedegree" name="postgraduatedegree" class="form-control"
            formControlName="postgraduatedegree">
          <!-- <button type="button" class="bb"><span class="glyphicon glyphicon-plus"></span> Add</button> -->
        </div>

      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="postgraduatecollege">Postgraduate College: </label>
          <input type="text" id="postgraduatecollege" name="postgraduatecollege" class="form-control"
            formControlName="postgraduatecollege">
          <!-- <button type="button" class="bb"><span class="glyphicon glyphicon-plus"></span> Add</button> -->
        </div>

      </div>

    </div>
    <div class="row">
      <!-- <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="othercertificate">Other Certifications </label>
          <input type="text" name="othercertificate" class="form-control">
          </div>
      </div> -->
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="experienceFrom">Experience From:</label>
          <input type="text" name="experienceFrom" id="experienceFrom" class="form-control"
            formControlName="experienceFrom">
          <!-- <button type="button" class="bb"><span class="glyphicon glyphicon-plus"></span> Add More</button> -->
        </div>

      </div>

    </div>
    <div class="row">
      <h5>Credential</h5>
      <p>Note:Upload file size should not exceed 2MB and Format should be only PDF, .DOC, .DOCX, .JPG,.JPEG & .PNG</p>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">

        <div class="form-group">
          <label for="Address1">Upload ID Proof: </label>
          <div class="upload-btn-wrapper">

            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" name="myfile1" class="form-control" multiple [accept]="acceptFilesFormat"
                (change)="selectedFiles('ID Proof',$event)" />
              <p *ngFor="let file of getAllFiles[0]?.documentIds">
                <small> {{file.fileName }}<a (click)="removeFileById('ID Proof',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>
            <!-- {{IdProof?.documentIds[0].fileName}} -->
            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="Address1">Upload Profile Photo: </label>
          <div class="upload-btn-wrapper">
            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" class="form-control" name="myfile2" class="form-control" [accept]="acceptFilesFormat"
                (change)="selectedFiles('Profile Photo',$event)" />
              <p *ngFor="let file of getAllFiles[1]?.documentIds">
                <small> {{file.fileName }}<a (click)="removeFileById('Profile Photo',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>
            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="form-group">
          <label for="Address1">Upload Address Proof: </label>
          <div class="upload-btn-wrapper">
            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" class="form-control" name="addressproof" multiple [accept]="acceptFilesFormat"
                (change)="selectedFiles('Address Proof',$event)" />
              <p *ngFor="let file of getAllFiles[2]?.documentIds">
                <small> {{file.fileName}}<a (click)="removeFileById('Address Proof',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>

            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="Address1">Upload State Registration Certificate: </label>
          <div class="upload-btn-wrapper">
            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" class="form-control" name="state Cert" multiple [accept]="acceptFilesFormat"
                (change)="selectedFiles('State Registration Certificate',$event)" />
              <p *ngFor="let file of getAllFiles[3]?.documentIds">
                <small> {{file.fileName}}<a (click)="removeFileById('State Registration Certificate',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>
            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="Address1">Upload Undergraduate Certificate: </label>
          <div class="upload-btn-wrapper">
            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" class="form-control" name="Undergraduate" multiple [accept]="acceptFilesFormat"
                (change)="selectedFiles('Undergraduate Certificate',$event)" />
              <p *ngFor="let file of getAllFiles[4]?.documentIds">
                <small> {{file.fileName}}<a (click)="removeFileById('Undergraduate Certificate',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>
            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="Address1">Upload Postgraduate Certificate:</label>
          <div class="upload-btn-wrapper">
            <button class="btn-field"><i class="bi bi-arrow-up-circle"></i>
              <input type="file" class="form-control" name="postgraduate" class="form-control" multiple
                [accept]="acceptFilesFormat" (change)="selectedFiles('Postgraduate Certificate',$event)" />
              <p *ngFor="let file of getAllFiles[5]?.documentIds">
                <small> {{file.fileName}}<a (click)="removeFileById('Postgraduate Certificate',file)"><i
                      class="bi bi-x-circle-fill"></i></a></small>
              </p>
            </button>
            <!-- <div>
              <button class="right"><i class="glyphicon glyphicon-plus"></i>Add</button>
            </div> -->
          </div>
          <!-- <input type="text" id="Address1"  name="email"  class="ad2"> -->
        </div>
      </div>

    </div>
    <div style="text-align: center;">
      <button type="button" (click)="resetForm()" class="btn btn-success bb2">Clear Form</button>
      <button type="submit" class="btn btn-success bb" (click)="onSubmit()">Submit</button>
      <!-- [ngClass]="!doctorRegistrationForm.valid?'btnDisable':'btn-success'" [disabled]="!doctorRegistrationForm.valid" -->
    </div>


    <ng-template #msg>
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Message</h4>
        <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
            class="bi bi-x-circle"></i></button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <p class="text-center">{{modalService.config.initialState.message}}</p>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
        <button type="button" class="btn-blue" (click)="modalClose()" routerLink="/login">OK</button>
      </div>
    </ng-template>